import { Container } from '@farol-ds/react'
import {
  TemporaryOfferBanner,
  TemporaryOfferBannerProps,
} from '@jusbrasil-web/shared-temporary-offer-banner'

import styles from './temporary-offer-banner-wrapper.module.scss'

export function TemporaryOfferBannerWrapper(props: TemporaryOfferBannerProps) {
  return (
    <Container>
      <TemporaryOfferBanner className={styles.temporaryOfferBanner} {...props} />
    </Container>
  )
}
